import { render } from "./IconFacebook.vue?vue&type=template&id=5f6c50c2"
import script from "./IconFacebook.vue?vue&type=script&lang=js"
export * from "./IconFacebook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__